"use client";

import Image from "next/image";
import { Button } from "@/components/ui/Button";
import { Github, FolderOpen } from "lucide-react";

export function GithubIntegrationShowcase() {
  return (
    <section className="py-16 px-4 md:px-12 lg:px-24 bg-gradient-to-b from-bg-card to-bg-grid text-white">
      <div className="max-w-6xl mx-auto grid md:grid-cols-5 gap-12 items-center">
        {/* Text Content */}
        <div className="md:col-span-2">
          <h2 className="text-3xl md:text-5xl font-bold mb-6 leading-tight">
            Start with Your GitHub Repo
          </h2>
          <p className="text-lg text-card-foreground/30 mb-6">
            Use your own public or private GitHub repositories as a starting
            point.
          </p>

          <div className="space-y-4">
            <div className="flex items-center">
              <Github className="text-green-400 w-5 h-5 mr-2" />
              <span>Connect GitHub account to import repos</span>
            </div>
            {/* <div className="flex items-center">
              <FolderOpen className="text-blue-400 w-5 h-5 mr-2" />
              <span>Pick from pre-designed, customizable templates</span>
            </div> */}
          </div>

          <div className="mt-8 flex gap-4">
            <Button className="bg-green-600 hover:bg-green-700 text-white">
              Import from GitHub
            </Button>
            <Button
              variant="outline"
              className="text-white border-gray-600 hover:border-white"
            >
              Browse Templates
            </Button>
          </div>
        </div>

        {/* Screenshot Image */}
        <div className="md:col-span-3 rounded-xl overflow-hidden shadow-lg border border-gray-800">
          <Image
            src="/images/screenshots/create-project-screenshot.png"
            alt="GitHub Import Screenshot"
            width={1200}
            height={800}
            className="w-full h-auto object-cover"
          />
        </div>
      </div>
    </section>
  );
}
